/*
 * @format
 *
 * Helpers for initalising event objects
 */

import { DAYS_OF_WEEK } from '../utils/consts';

export const event = (day, startTime, setpoint) => {
  if (typeof setpoint === 'number' || typeof setpoint === 'string') {
    return { day, startTime, setpoint };
  } else if (typeof setpoint === 'boolean') {
    return { day, startTime, on: setpoint };
  }

  throw Error('Invalid setpoint type');
};

export const eventUpdate = (day, startTime, endTime, setpoint) => {
  return { day, startTime, endTime, setpoint };
};

export const daySortIndex = day => {
  switch (day) {
    case DAYS_OF_WEEK.MONDAY:
      return 0;
    case DAYS_OF_WEEK.TUESDAY:
      return 1;
    case DAYS_OF_WEEK.WEDNESDAY:
      return 2;
    case DAYS_OF_WEEK.THURSDAY:
      return 3;
    case DAYS_OF_WEEK.FRIDAY:
      return 4;
    case DAYS_OF_WEEK.SATURDAY:
      return 5;
    case DAYS_OF_WEEK.SUNDAY:
      return 6;
    default:
      throw Error('Unknown day constant used');
  }
};

export const nextDay = day => {
  switch (day) {
    case DAYS_OF_WEEK.MONDAY:
      return DAYS_OF_WEEK.TUESDAY;
    case DAYS_OF_WEEK.TUESDAY:
      return DAYS_OF_WEEK.WEDNESDAY;
    case DAYS_OF_WEEK.WEDNESDAY:
      return DAYS_OF_WEEK.THURSDAY;
    case DAYS_OF_WEEK.THURSDAY:
      return DAYS_OF_WEEK.FRIDAY;
    case DAYS_OF_WEEK.FRIDAY:
      return DAYS_OF_WEEK.SATURDAY;
    case DAYS_OF_WEEK.SATURDAY:
      return DAYS_OF_WEEK.SUNDAY;
    case DAYS_OF_WEEK.SUNDAY:
      return DAYS_OF_WEEK.MONDAY;
    default:
      throw Error('Unknown day constant used');
  }
};

export const shortenDay = day => {
  const locationOfSAfterFirstChar = day.indexOf('s', 1);

  if (locationOfSAfterFirstChar !== -1) {
    if (locationOfSAfterFirstChar <= 4) {
      return day.substring(0, locationOfSAfterFirstChar + 1);
    }
  }

  return day.substring(0, 3);
};
